import { rankWith, uiTypeIs, LayoutProps } from '@jsonforms/core';
import {
  ResolvedJsonFormsDispatch,
  withJsonFormsLayoutProps,
} from '@jsonforms/react';

import { getElements } from '../../../../../utils/DynamicForms';

import './style.scss';

type Props = LayoutProps; // use correct prop type

const VerticalSections = (props: Props) => {
  const elements = getElements(props.uischema);

  return (
    <div className="tru-layout-vertical-sections">
      <div className="content">
        {elements.map((element, i) => (
          <div key={`tab-content-${i}`}>
            <ResolvedJsonFormsDispatch {...props} uischema={element} />
          </div>
        ))}
      </div>
    </div>
  );
};

export const VerticalSectionsEntry = {
  tester: rankWith(1, uiTypeIs('VerticalSections')),
  renderer: withJsonFormsLayoutProps(VerticalSections),
};
